import React, { useEffect, useState } from "react";
import { Heart } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";

export function FavoriteButton({ place }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [favorited, setFavorited] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (user && Array.isArray(user.favorites)) {
      setFavorited(user.favorites.some((f) => f.place_id === place.place_id));
    } else {
      setFavorited(false);
    }
  }, [user, place.place_id]);

  const toggle = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user) {
      toast.info("Sign in to save favorites");
      navigate("/login");
      return;
    }
    setBusy(true);
    try {
      if (favorited) {
        await api.delete(`/favorites/${place.place_id}`);
        setFavorited(false);
      } else {
        await api.post("/favorites", place);
        setFavorited(true);
        toast.success("Added to favorites");
      }
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      onClick={toggle}
      disabled={busy}
      data-testid={`favorite-btn-${place.place_id}`}
      aria-label={favorited ? "Remove favorite" : "Add to favorites"}
      className="absolute top-4 right-4 w-10 h-10 rounded-full bg-white/90 backdrop-blur-sm flex items-center justify-center shadow-md hover:scale-110 transition-transform z-10"
    >
      <Heart
        className={`w-5 h-5 transition-colors ${
          favorited ? "fill-red-500 text-red-500" : "text-primary"
        }`}
      />
    </button>
  );
}
